import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import "./InvoicesModal.css";

function InvoicesModal({ open, onClose, onSubmit }) {
  const [invoices, setInvoices] = useState([{ invoice_number: "", cufe: "" }]);
  const [errorMessage, setErrorMessage] = useState("");

  const handleAddInvoice = () => {
    setInvoices([...invoices, { invoice_number: "", cufe: "" }]);
  };

  const handleInvoiceChange = (index, event) => {
    const values = [...invoices];
    values[index][event.target.name] = event.target.value;
    setInvoices(values);
  };

  const handleRemoveInvoice = (index) => {
    const values = [...invoices];
    if (values.length > 1) {
      values.splice(index, 1);
      setInvoices(values);
    }
  };

  const handleSubmit = () => {
    for (const invoice of invoices) {
      if (!invoice.invoice_number || !invoice.cufe) {
        setErrorMessage("Todos los campos de factura son requeridos.");
        return;
      }
    }
    setErrorMessage("");
    onSubmit(invoices);
    setInvoices([{ invoice_number: "", cufe: "" }]);
    onClose();
  };

  const handleClose = () => {
    setInvoices([{ invoice_number: "", cufe: "" }]);
    setErrorMessage("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="simple-dialog-title" style={{ margin: "0 auto" }}>
          <h4>Facturas Asociadas</h4>
        </DialogTitle>
      <DialogContent>
        {invoices.map((invoice, index) => (
          <div key={index} className="invoice-inputs">
            <input
              type="text"
              name="invoice_number"
              placeholder="Factura No"
              value={invoice.invoice_number}
              onChange={(e) => handleInvoiceChange(index, e)}
              className="my_input"
            />
            <input
              type="text"
              name="cufe"
              placeholder="CUFE"
              value={invoice.cufe}
              onChange={(e) => handleInvoiceChange(index, e)}
              className="my_input"
            />
            <button
              type="button"
              onClick={() => handleRemoveInvoice(index)}
              className="remove-invoice-btn"
            >
              <FontAwesomeIcon icon={faMinusCircle} color="red" />
            </button>
          </div>
        ))}
        <div className="add-invoice-container">
            <div className="add-invoice-btn-container"> 

          <button
            type="button"
            onClick={handleAddInvoice}
            className="add-invoice-btn"
            >
            <FontAwesomeIcon icon={faPlusCircle} />
          </button>
              </div>
        </div>
        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
      </DialogContent>
      <DialogActions>
        <button onClick={handleClose} className="button-cancel">
          Cancelar
        </button>
        <button onClick={handleSubmit} className="button-save">
          Guardar y cerrar
        </button>
      </DialogActions>
    </Dialog>
  );
}

export default InvoicesModal;
